interface IPerlgemSettings {
    pg_reqs: string;
    pg_headers: PGHeaders;
}

interface PGHeaders {
    Host: string;
    user_agent: string;
}

const getGlobalPerlgemSettings: () => IPerlgemSettings = () =>
    // @ts-ignore
    window.Drupal.settings.perlgem;

export const getBrandAndRegion = () => {
    const perlgemRequirements = getGlobalPerlgemSettings().pg_reqs;
    const [, regionId] = new RegExp('&?\\W?region_id=(\\d+)').exec(perlgemRequirements) || ['', ''];
    const [, brandId] = new RegExp('&?\\W?brand_id=(\\d+)').exec(perlgemRequirements) || ['', ''];

    return {
        brandId,
        regionId
    };
};
